<template>
  <div>
    <ContasBancariasFiltros @filtrar="carregarContasBancarias" />
    <ContasBancariasTable :dados="contasBancarias.contasVinculadas" :carregando="carregando" />

    <ContasBancariasPaginacao
      :page="page"
      :pageSize="pageSize"
      :totalDeRegistros="contasBancarias.registrosTotais"
      @paginaMudou="handlePageChange"
      @tamanhoPaginaMudou="handleSizeChange"
    />
  </div>
</template>

<script>
import ContasBancariasFiltros from '../ContasBancarias/ContasBancariasFiltro.vue'
import ContasBancariasTable from '../ContasBancarias/ContasBancariasTable.vue'
import ContasBancariasPaginacao from '../ContasBancarias/ContasBancariasPaginacao.vue'

export default {
  components: {
    ContasBancariasFiltros,
    ContasBancariasTable,
    ContasBancariasPaginacao
  },
  data() {
    return {
      contasBancarias: {
        contasVinculadas: [],
        registrosTotais: 0
      },
      carregando: false,
      page: 1,
      pageSize: 25
    };
  },
  methods: {
    async carregarContasBancarias(filtros = {}) {
      this.carregando = true;
      try {
        const params = {
          ...filtros,
          Pagina: this.page,
          PorPagina: this.pageSize
        };
        const response = await this.axios.get(this.$urls.OBTER_CONTAS_VINCULADAS, { params });
        this.contasBancarias = response.data;
      } catch (error) {
        console.error('Erro ao carregar contas bancárias:', error);
      } finally {
        this.carregando = false;
      }
    },
    handlePageChange(novaPagina) {
      this.page = novaPagina;
      this.carregarContasBancarias();
    },
    handleSizeChange(novoTamanho) {
      this.pageSize = novoTamanho;
      this.page = 1;
      this.carregarContasBancarias();
    }
  },
  mounted() {
    this.carregarContasBancarias();
  }
}
</script>
